import BudgetOverview from 'views/BudgetOverview';
import BudgetAllocation from 'views/BudgetAllocation';
import StateRevenue from 'views/StateRevenue';
import KeyIndicators from 'components/KeyIndicators';
import Gdp from 'views/Gdp';

export const routes = [
  {
    url: '/budget-overview',
    component: BudgetOverview,
    exact: true,
  },
  {
    url: '/budget-allocation',
    component: BudgetAllocation,
  },
  {
    url: '/gross-domestic-product',
    component: Gdp,
  },
  {
    url: '/state-revenue',
    component: StateRevenue,
  },
  {
    url: '/key-indicator',
    component: KeyIndicators,
  },
];
